import { Text } from '@ghq-abi/design-system';
import { useTranslate } from '@tolgee/react';
import { NominatedAssignmentEnum } from 'abi-lcm-common-types';

type RaterRelationshipProps = {
  nominatedAssignment?: NominatedAssignmentEnum;
};

export function RaterRelationship({
  nominatedAssignment,
}: RaterRelationshipProps) {
  const { t } = useTranslate('default');
  return (
    <Text
      css={{
        display: 'block',
        fontSize: '$xs',
        color: '$gray575',
        fontWeight: '$normal',
      }}
    >
      {`${t('rater_relationship.title')}: `}
      <Text as="span" css={{ fontWeight: 'bold', fontSize: '$xs' }}>
        {t(`rater_relationship.${nominatedAssignment}`)}
      </Text>
    </Text>
  );
}
